<!-- Schedule/Visit -->
<template>
  <validation-observer ref="form">
    <div class="row">
      <div class="col-lg-12">
        <base-input
          label="Nome do Cliente"
          :required="true"
          rules="required"
          success-message="Campo preenchido"
        >
          <multiselect
            v-model="value.client"
            :options="clients"
            placeholder="Nome do Cliente"
            label="razao_social"
            track-by="id"
            @search-change="getClients"
            :select-label="''"
            :deselect-label="''"
            selected-label="Selecionado"
          ></multiselect>
        </base-input>
      </div>
      <div class="col-lg-12">
        <base-input
          :valid="true"
          type="text"
          placeholder="Email"
          v-model="formData.email"
          aria-label="Email"
          label="Email"
          :required="true"
          rules="required"
          success-message="Campo preenchido"
          :error="validateEmail(formData.email)"
        ></base-input>
      </div>

      <div class="col-lg-12">
        <base-input
          label="Endereço"
          :valid="true"
          type="text"
          placeholder="Endereço"
          v-model="formData.address"
          aria-label="Endereço"
        ></base-input>
      </div>

      <div class="col-lg-12">
        <base-input
          label="Data e hora da visita"
          :required="true"
          rules="required"
          :error="errors[0]"
          success-message="Campo preenchido"
        >
          <el-date-picker
            v-model="dateRange"
            :picker-options="{ disabledDate: disabledDate }"
            type="datetimerange"
            range-separator="-"
            start-placeholder="Data início"
            end-placeholder="Data fim"
            prefix-icon="fa fa-calendar"
            format="dd/MM/yyyy HH:mm"
            unlink-panels
            :required="true"
            :editable="true"
          ></el-date-picker>
        </base-input>
      </div>

      <div class="col-lg-12">
        <base-input
          label="Descrição"
          :valid="true"
          type="text"
          placeholder="Descrição"
          v-model="formData.note"
          aria-label="Descrição"
        ></base-input>
      </div>

      <div class="form-group col-lg-12">
        <label class="form-control-label d-block mb-3">Status cor</label>
        <base-color-selector :required="true" v-model="formData.color" :colors="colors" />
      </div>

      <div class="col-lg-12">
        <label class="form-control-label d-block mb-3">Anexar Imagens e Vídeos</label>
        <file-input
          :files="[]"
          @update:files="addFile($event)"
          multiple
        ></file-input>
        <br>
        <br>
        <!-- @remove="support.files = support.files.filter((f) => f != $event)" -->
        <file-list :files.sync="files" remove @remove="removeFile($event)" />
      </div>
    </div>
  </validation-observer>
</template>

<script>
import BaseColorSelector from "@/components/BaseColorSelector.vue";
import { DatePicker, } from "element-ui";
import Multiselect from "@/components/Multiselect/translated_multiselect.vue";
import FileList from "@/components/FileList";
import { extend } from "vee-validate";

import { required } from "vee-validate/dist/rules";
extend("required", {
  ...required,
  message: "Este campo é obrigatório",
});

export default {
  name: "ScheduleForm",
  components: {
    BaseColorSelector,
    Multiselect,
    FileList,
    [DatePicker.name]: DatePicker,
  },
  props: {
    value: {
      type: Object,
      default: () => ({
        id: null,
        title: "",
        start: null,
        end: null,
        color: "",
        note: "",
        client: "",
        email: "",
        address: "",
        visitType: "",
        client_id: null,
      }),
    },
    disabledDate: {
      type: Function,
      default: () => () => false,
    },
  },
  data: () => ({
    clients: [],
    clientRequestIndex: 0,
    colors: [
      { value: "bg-info",   name: "Unidade" },
      { value: "bg-orange", name: "Corporativo" },
      { value: "bg-red",    name: "Apresentação" },
      { value: "bg-green",  name: "Aberto" },
    ],
    errors: [],
  }),
  computed: {
    client: {
      get() {
        return this.clients.find((client) => client.id === this.formData.client_id) || { id: this.formData.client_id, razao_social: this.formData.client };
      },
      set(value) {
        this.formData = { ...this.formData, client_id: value.id };
      },
    },
    formData: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
    dateRange: {
      get() {
        if (this.formData.date_start && this.formData.date_end) {
          return [this.formData.date_start, this.formData.date_end];
        }

        return null;
      },
      set(value) {
        if (value && value.length === 2){
          this.formData = { ...this.formData, date_start: value[0], date_end: value[1] };
          return
        }

        this.formData = { ...this.formData, date_start: null, date_end: null };
      },
    },
    files: {
      get() {
        return this.value.media || [];
      },
      set(value) {
        this.formData = { ...this.formData, media: value };
      },
    },
    currentUser() {
      return JSON.parse(localStorage.currentUser) || {};
    }
  },
  mounted() {
    this.getClients();
  },
  methods: {
    async getClients(query) {
      const queryData = {
        q: {},
        per_page: 10,
      };
      const currentRequestIndex = ++this.clientRequestIndex;

      if (query) queryData.q.razao_social = query;

      if (this.currentUser.is_admin) {
        queryData.q = {};
      } else {
        if      (this.currentUser.is_manager)     queryData.q.manager_ids     = this.currentUser.id;
        else if (this.currentUser.is_coordinator) queryData.q.coordinated_ids = this.currentUser.coordinated_ids;
        else                                      queryData.q.user_ids        = this.currentUser.id;
      }

      try {
        const response = await this.$http.secured.get("/api/v1/clients", {
          params: queryData
        })

        if (currentRequestIndex !== this.clientRequestIndex) return;

        this.clients = response.data.clients || []
      } catch (error) {
        console.warn("[ScheduleForm][getClients]", error)
      }
    },
    validateEmail(email) {
      const re = /\S+@\S+\.\S+/;
      return (!email || re.test(email)) ? "" : "Email inválido";
    },
    clearForm() {
      this.$refs.form.reset();
    },
    addFile(files) {
      this.files = [...this.files, ...files];
    },
    removeFile(file) {
      if (!file.signed_id) return;
      if (!this.formData.destroy_media) this.formData.destroy_media = [];

      this.formData.destroy_media = [...this.formData.destroy_media, file.signed_id];
    },
  },
}
</script>

<style lang="scss">
@import "~@fullcalendar/core/main.css";
@import "~@fullcalendar/daygrid/main.css";
@import "~@fullcalendar/timegrid/main.css";
@import "~@/assets/sass/core/vendors/fullcalendar";
</style>
